<template>
    <div>
      <van-nav-bar
        title="查询"
        left-text="返回"
        left-arrow
        style="background-color: #00c4fb"
        @click-left="$emit('back', null)"  >
        <template #left>
				<span style="color: #ffffff ;">
					<van-icon :name="back" style="color: white;"/>
          <!-- <span>back</span> -->
				 </span>
        </template>
        <template #title>
          <span style="color: #ffffff ; ">{{headName}} </span>
        </template>
      </van-nav-bar>
    </div>
</template>

<script>
  import back from '../../../src/assets/icon/back.png'
    export default {
      props:{
        headName: {
          type: String
        }
      },
        name: "Header",
      data() {
        return {
          back:back
        }},

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/com/Header.vue